// Visual guides for the Plaza beach map: walking-path arrows + the Plazni Bar box.
// Coordinates are in the same unscaled space as baldachin x/y positions.
export const BEACH_DECORATIONS = {
  arrows: [
    // Horizontal walking path (points right), runs below the main grid
    { id: "path-horizontal", x1: 110, y1: 888, x2: 1240, y2: 888 },
    // Vertical walking path (points down), runs between the grid and right wing
    { id: "path-vertical", x1: 1258, y1: 150, x2: 1258, y2: 950 },
  ],
  labels: [
    { id: "plazni-bar", x: 470, y: 1206, w: 300, h: 58, text: "Plazni Bar" },
  ],
};
